exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".displaySettings .setting{margin-bottom:1em}.displaySettings .setting:last-child{margin-bottom:0}select:disabled{cursor:not-allowed}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/SettingsModal/DisplaySettings/DisplaySettings.scss
 ** module id = 754
 ** module chunks = 0
 **/